import decode from 'jwt-decode';
import {
  LOGIN,
  LOGOUT,
  SET_USER_DATA,
  SET_USER_TOKEN,
  SET_ONBOARDING_OVERLAY,
  SET_HAS_CHARGEBEE_CUSTOMER,
} from '../types';

const initialState = {
  isLoggedIn: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isLoggedIn: true,
      };
    case LOGOUT:
      return {
        ...initialState,
        lastLogoutType: action.logoutType,
      };
    case SET_USER_TOKEN: {
      const decodedToken = decode(action.token);
      return {
        ...state,
        token: action.token,
        decodedToken,
      };
    }
    case SET_USER_DATA:
      return {
        ...state,
        ...action.user,
        isLoggedIn: true,
      };
    case SET_ONBOARDING_OVERLAY:
      return {
        ...state,
        overlays: {
          ...state.overlays,
          ...action.overlays,
        },
      };

    case SET_HAS_CHARGEBEE_CUSTOMER: {
      return {
        ...state,
        hasChargebeeCustomer: action.hasChargebeeCustomer,
      };
    }

    default:
      return state;
  }
}
